import React, { useEffect, useState } from 'react';
import SortableItemList from '../../../../components/SortableItemList';
import { activateAuthLayout } from '../../../../store/actions';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { ModalBody, ModalFooter, Form, FormGroup, Label, Input, Button } from 'reactstrap';

const DATA = gql`
  query getData {
    CAFSections {
      CAFSectionId
      Name
      SortOrder
    }
  }
`;

const CREATE_CAF_SECTION = gql`
  mutation createCAFSection($input: CAFSectionInput) {
    createCAFSection(input: $input) {
      CAFSectionId
      Name
      SortOrder
    }
  }
`;

const UPDATE_CAF_SECTION = gql`
  mutation updateCAFSection($input: CAFSectionInput) {
    updateCAFSection(input: $input) {
      CAFSectionId
      Name
      SortOrder
    }
  }
`;

const DELETE_CAF_SECTION = gql`
  mutation deleteCAFSection($CAFSectionId: Int!) {
    deleteCAFSection(CAFSectionId: $CAFSectionId) {
      CAFSectionId
    }
  }
`;

const CAFSectionForm = ({ item, onSave, onClose }) => {
  const [name, setName] = useState(item?.Name ?? '');

  const save = (e) => {
    e?.preventDefault();
    Promise.resolve(onSave(name)).then(onClose);
  };

  return (
    <>
      <ModalBody>
        <Form onSubmit={save}>
          <FormGroup>
            <Label>Section Name <small className="text-danger">*</small></Label>
            <Input
              type="text"
              value={name}
              onChange={e => setName(e.target.value)}
              onKeyPress={e => e.key === 'Enter' && name.trim() && save()}
              autoFocus
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose}>Cancel</Button>
        <Button color="primary" onClick={save} disabled={!name.trim()}>Save</Button>
      </ModalFooter>
    </>
  );
};

const CAFSections = ({ activateAuthLayout }) => {
  useEffect(() => { activateAuthLayout(); }, [activateAuthLayout]);

  const { data, loading, refetch } = useQuery(DATA);
  const [createCAFSection] = useMutation(CREATE_CAF_SECTION);
  const [updateCAFSection] = useMutation(UPDATE_CAF_SECTION);
  const [deleteCAFSection] = useMutation(DELETE_CAF_SECTION);

  return (
    <SortableItemList
      title="CAF Sections"
      loading={loading}
      items={data?.CAFSections ?? []}
      getKey={s => s.CAFSectionId}
      getLabel={s => s.Name}
      droppableId="caf-sections"
      onReorder={reordered => reordered.forEach((s, i) =>
        updateCAFSection({ variables: { input: { CAFSectionId: s.CAFSectionId, SortOrder: i + 1 } } })
      )}
      onDelete={s =>
        deleteCAFSection({ variables: { CAFSectionId: s.CAFSectionId } }).then(() => refetch())
      }
      deleteWarning={s => `Delete "${s.Name}"? Any CAF templates assigned to this section will be unassigned.`}
      createLabel="Create Section"
      editLabel="Rename"
      createTitle="Create Section"
      editTitle="Rename Section"
      emptyMessage="No CAF sections exist."
      renderForm={(item, close) => (
        <CAFSectionForm
          item={item}
          onClose={close}
          onSave={name => item
            ? updateCAFSection({ variables: { input: { CAFSectionId: item.CAFSectionId, Name: name } } }).then(() => refetch())
            : createCAFSection({ variables: { input: { Name: name } } }).then(() => refetch())
          }
        />
      )}
    />
  );
};

export default connect(null, { activateAuthLayout })(CAFSections);
